import { Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./sidebar";
import { useEffect, useState } from "react";
import axios from "axios"

const ProtectedRouteMachine = () => {

    const location = useLocation();

    const [isMachineValid, setisMachineValid] = useState(null)

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }


    // first check for machine validation, if validation ok then check for login status

    const checkIfDeviceIsValid = async () => {

        const localStorageCompanyCode = localStorage.getItem("masterCompanyCode") ? localStorage.getItem("masterCompanyCode") : "-"
        const localStorageCompanyPublicKey = localStorage.getItem("companyPublicKey") ? localStorage.getItem("companyPublicKey") : "-"
        const localStorageCompanyPrivateKey = localStorage.getItem("companyPrivateKey") ? localStorage.getItem("companyPrivateKey") : "-"

        const checkDeviceValidateApiPromise = new Promise((resolve) => {

            const url = `https://cubixweberp.com:199/CheckStatus?cmpcode=${localStorageCompanyCode}&publick=${localStorageCompanyPublicKey}&privatek=${localStorageCompanyPrivateKey}`;
            console.log(url);

            axios.get(url).then((res) => {

                if (res.data?.length > 0) {

                    if (res?.data[0].Column1 === 'VALIDATED') {
                        resolve(true)

                        setisMachineValid(true)

                        //sleep(5000).then(() => { console.log("after 5 seconds"); setisMachineValid(true) })

                    } else {
                        resolve(false)
                        setisMachineValid(false)
                    }
                } else {
                    resolve(false)
                    setisMachineValid(false)
                }


            }).catch((err) => {
                console.log("err", err)
                resolve(false)
            })
        })

        const resultOfAPI = await checkDeviceValidateApiPromise

        console.log("result of checkDeviceValidateApiPromise ", resultOfAPI)
        return resultOfAPI


    }



    useEffect(() => {

        console.log("inside useEffect ProtectedRouteMachine")

        checkIfDeviceIsValid()

    }, [])

    useEffect(() => {
        console.log("inside useEffect [location] ProtectedRouteMachine")
        checkIfDeviceIsValid()
    }, [location]);


    if (isMachineValid == null) {
        return <div><p>Loading</p></div>
    }

    return isMachineValid
        ?  <Outlet />
        : <Navigate to="/machine_registration" />;



};

export default ProtectedRouteMachine;
